import React from 'react';

interface BugReportIconProps {
  className?: string;
}

const BugReportIcon: React.FC<BugReportIconProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
      style={{ transform: 'scale(0.85)' }}
    >
      <path d="m13 10v1c0 .552-.448 1-1 1s-1-.448-1-1v-1c0-.552.448-1 1-1s1 .448 1 1zm-1 3c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zm8-6h-1.523l1.006 4h3.516c.553 0 1 .448 1 1s-.447 1-1 1h-3.013c.17.567.276 1.273.262 1.828 0 .756-.109 1.482-.295 2.172h.046c2.209 0 4 1.791 4 4v2c0 .552-.447 1-1 1s-1-.448-1-1v-2c0-1.105-.895-2-2-2h-.886c-1.42 2.408-4.043 3.997-7.113 4-3.074-.003-5.699-1.594-7.119-4h-.882c-1.105 0-2 .895-2 2v2c0 .552-.448 1-1 1s-1-.448-1-1v-2c0-2.209 1.791-4 4-4h.042c-.185-.686-.292-1.406-.293-2.157-.016-.534.093-1.282.264-1.843h-3.012c-.552 0-1-.448-1-1s.448-1 1-1h3.516l1.006-4h-1.522c-2.209 0-4-1.791-4-4v-2c0-.552.448-1 1-1s1 .448 1 1v2c0 1.105.895 2 2 2h2.08c.992-2.396 3.329-3.997 5.918-4 2.591.003 4.929 1.604 5.92 4h2.081c1.105 0 2-.895 2-2v-2c0-.552.447-1 1-1s1 .448 1 1v2c0 2.209-1.791 4-4 4zm-3.036 7.043-3.84-6.398c-.502-.861-1.746-.861-2.248 0l-3.84 6.398c-.506.867.12 1.957 1.124 1.957h7.68c1.004 0 1.63-1.089 1.124-1.957z"/>
    </svg>
  );
};

export default BugReportIcon;
